import WKT from "ol/format/WKT";
import { markerSource } from "./layers";
import { addDrawnFeatures } from "./draw";
import { zoomToExtent } from "./utils";
import { updateUrlDisplay } from "./url";
import { triggerSearch } from "./search";
import { maxDrawFeatures, maxDrawUrlLength } from "./config";

// Geometry types that can be drawn, and so the only ones accepted from the URL
const drawableTypes = ["Point", "LineString", "Polygon"];

export function initPage(map) {
  const queryParams = new URLSearchParams(window.location.search);

  const showSidebar = queryParams.get("showsidebar") === "true";
  if (showSidebar) {
    document.getElementsByClassName("sidebar")[0].style.display = "block";
  } else {
    document.getElementsByClassName("sidebar")[0].style.display = "none";
  }

  const query = queryParams.get("q");
  let match = queryParams.get("match");
  // Filter values that have been renamed, so older links keep working
  const legacyFilters = { "Park/torg": "Park/natur/torg" };
  const filters = queryParams.get("filter")
    ? queryParams
        .get("filter")
        .split(",")
        .map((filter) => (Object.hasOwn(legacyFilters, filter) ? legacyFilters[filter] : filter))
    : [];
  const showPopup = queryParams.get("showpopup");

  // Set the checkbox state based on the 'showpopup' parameter
  const popupCheckbox = document.getElementById("auto-popup-checkbox");
  if (showPopup === "false") {
    popupCheckbox.checked = false;
  } else {
    popupCheckbox.checked = true;
  }

  // Set Filters, compare values directly since they come from the URL and can't be trusted in a selector
  const filterCheckboxes = Array.from(document.querySelectorAll('#search-filters input[type="checkbox"]'));
  filterCheckboxes.forEach((checkbox) => {
    if (filters.includes(checkbox.value)) {
      checkbox.checked = true;
    }
  });

  // Set Match Type
  if (match) {
    const matchSelect = document.getElementById("search-match");
    if (matchSelect) {
      matchSelect.value = match;
    }
  }

  if (query) {
    document.getElementById("search-query").value = query;
    triggerSearch(map);
  } else {
    // Check for drawing parameters, 'drawType' and 'drawCoords' are kept for older links
    const draw = queryParams.get("draw");
    const drawType = queryParams.get("drawType");
    const drawCoords = queryParams.get("drawCoords");
    const wkt = draw || (drawType && drawCoords);
    if (wkt) {
      try {
        // The URL can come from anyone, reject drawings that are too large or not something that can be drawn
        if (wkt.length > maxDrawUrlLength) {
          throw new Error(`Drawing is longer than ${maxDrawUrlLength} characters`);
        }
        const format = new WKT();
        const geometry = format.readGeometry(wkt, {
          dataProjection: "EPSG:3008",
          featureProjection: map.getView().getProjection(),
        });
        const geometries = geometry.getType() === "GeometryCollection" ? geometry.getGeometries() : [geometry];
        if (geometries.length > maxDrawFeatures) {
          throw new Error(`Drawing has more than ${maxDrawFeatures} features`);
        }
        if (!geometries.every((part) => drawableTypes.includes(part.getType()))) {
          throw new Error(`Drawing can only contain ${drawableTypes.join(", ")}`);
        }
        addDrawnFeatures(geometries);
        zoomToExtent(map, markerSource.getExtent());
      } catch (error) {
        console.error("Invalid drawing in URL:", error);
      }
    }
  }

  updateUrlDisplay();
}
